/**
 * VENDOR
 */
// global.$ = global.jQuery = require('jquery');
window.$ = window.jQuery = require('jquery');
// require('jquery-ui');
import 'bootstrap';
import 'jquery-ui/ui/widgets/tabs.js';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/slider.js';
import 'autocomplete.js/dist/autocomplete.jquery.min.js';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

Swiper.use([Autoplay, Navigation, Pagination]);
window.Swiper = Swiper;
window.MarkerClusterer = MarkerClusterer;

global.autosize = require('autosize/dist/autosize');

require('@nobleclem/jquery-multiselect');
require('moment');
require('select2');
require('blueimp-file-upload');
require('magnific-popup');
require('@rwap/jquery-ui-touch-punch');


/**
 * APP
 */
require('./components/loader.js');
require('./components/forms.js');
require('./components/ajax-handler.js');
require('./components/page-title.js');
